export const ADD_TODO="ADD_TODO";
export const DELETE_TODO="DELETE_TODO";
export const TOGGLE_COMPLETED="TOGGLE_COMPLETED";
export const TOGGLE_IMPORTANT="TOGGLE_IMPORTANT";

